import { Controller } from "@hotwired/stimulus"

// Regenerates the CAPTCHA code server-side and swaps in the new image via
// fetch — no page navigation, so the rest of the form (its typed values,
// scroll position, etc.) is left untouched.
export default class extends Controller {
  static targets = ["image", "input"]
  static values = { url: String }

  async refresh(event) {
    event.preventDefault()

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": token, "X-Requested-With": "XMLHttpRequest" }
    })
    if (!response.ok) return

    const blob = await response.blob()
    if (this.hasImageTarget) {
      if (this.imageTarget.dataset.blobUrl) URL.revokeObjectURL(this.imageTarget.dataset.blobUrl)
      const url = URL.createObjectURL(blob)
      this.imageTarget.src = url
      this.imageTarget.dataset.blobUrl = url
    }
    if (this.hasInputTarget) this.inputTarget.value = ""
  }
}
